var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex-row flex-spbt"},[_c('p',{staticClass:"component-title"},[_vm._v(_vm._s(_vm.$t('TheNavbar.setComment')))])]),_c('ImprovedFeedbackCommentSetting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }